/**
 * Reusable Page Header Component
 * Dark mode geek aesthetic
 */

interface PageHeaderProps {
  title: string
  subtitle?: string
  count?: number
  subtitleColor?: 'cyan' | 'purple' | 'pink' | 'amber'
  titleGradient?: 'from-cyan-400 to-purple-400' | 'from-cyan-400 to-pink-400' | 'from-cyan-400 to-amber-400'
}

export default function PageHeader({
  title,
  subtitle,
  count,
  subtitleColor = 'cyan',
  titleGradient = 'from-cyan-400 to-purple-400',
}: PageHeaderProps) {
  const colorClasses = {
    cyan: 'text-cyan-400',
    purple: 'text-purple-400',
    pink: 'text-pink-400',
    amber: 'text-amber-400',
  }

  return (
    <div>
      <h1 className={`text-4xl font-black bg-linear-to-r ${titleGradient} bg-clip-text text-transparent`}>
        {title}
      </h1>
      {subtitle && (
        <p className="text-slate-400 mt-2 font-mono text-sm">
          {'> '} <span className={colorClasses[subtitleColor]}>{subtitle}</span>
          {count !== undefined && (
            <>
              {' --count='}
              <span className="text-cyan-400">{count}</span>
            </>
          )}
        </p>
      )}
    </div>
  )
}
